<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="col-lg-12">
          <div
            class="text-sm text-center copyright"
            :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            © {{ new Date().getFullYear() }},
            <a href="https://axelivacloud.com/" class="font-weight-bold" target="_blank">
              AxelivaCloud.
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
};
</script>

<style scoped>
/* Scoped styles are handled dynamically by Navbar.vue, 
   but you can add a transition here for smoothness */
.footer {
  transition: background-color 0.3s ease, width 0.3s ease;
}
</style>